import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@/app/core/auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Rutas públicas de auth (sin JWT)
  if (
    req.url.includes('/auth/login') ||
    req.url.includes('/auth/register-client') ||
    req.url.includes('/auth/forgot-password') ||
    req.url.includes('/auth/reset-password')
  ) {
    return next(req);
  }

  const authService = inject(AuthService);
  const token = authService.getToken();

  if (!token) {
    return next(req);
  }

  const reqWithAuth = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(reqWithAuth);
};
